module.exports = __webpack_public_path__ + "static/img/isHelpIcon.563cf617.png";